import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CookieService } from 'ngx-cookie-service';

import { ActualRouteInterceptor } from '../shared/interceptors/actual-route.interceptor';
import { HttpRequestInterceptor } from '../shared/interceptors/http-request-interceptor';
import { SharedModule } from '../shared/shared.module';
import { FooterComponent } from './footer/footer.component';
import { NavbarFinancialProfileComponent } from './navbar/navbar-financial-profile/navbar-financial-profile.component';
import { NavbarComponent } from './navbar/navbar.component';

@NgModule({
	imports: [CommonModule, RouterModule, SharedModule],
	declarations: [NavbarComponent, FooterComponent, NavbarFinancialProfileComponent],
	exports: [NavbarComponent, FooterComponent, NavbarFinancialProfileComponent],
})
export class CoreModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		if (parentModule) {
			throw new Error('CoreModule is already loaded. Import it in the AppModule only');
		}
	}

	static forRoot(): ModuleWithProviders<CoreModule> {
		return {
			ngModule: CoreModule,
			providers: [
				CookieService,
				{ provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
				{ provide: HTTP_INTERCEPTORS, useClass: ActualRouteInterceptor, multi: true },
			],
		};
	}
}
